import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import { useStyles } from './style';
import { useMediaQuery } from '@mui/material';
import { useUser, useUserDispatcher, useBusinessDispatcher, useBusiness } from 'hooks';
import { AuthService } from 'components/Auth';
import { getBusinessApi, reportAccountNumber, reportTransaction } from './MainServices';
import { Topbar, Footer } from './components';
import { SidebarNew } from 'components';

import 'react-perfect-scrollbar/dist/css/styles.css';
import createToast from 'components/Toast/Toast';
import { AnimatePresence, motion } from 'framer-motion';
import { truncate } from 'lodash';

const Main = (props) => {
  const { children } = props;

  const { pathname } = useLocation();
  const pageVariants = {
    initial: {
      opacity: 0,
      scale: 1.01,
    },
    in: {
      opacity: 1,
      scale: 1,
    },
    out: {
      opacity: 0,
    },
  };

  const pageTransition = {
    type: 'tween',
    ease: 'linear',
    duration: 0.5,
  };

  const user = useUser();
  const setUser = useUserDispatcher();
  const setBusinessDispatcher = useBusinessDispatcher();
  const businessInfo = useBusiness();
  const [dataBussinesss, setDataBussinesss] = useState(null);
  const [isShowContent, setIsShowContent] = useState(true); // collapse menu
  const [mobileIsShow, setMobileIsShow] = useState(true); // collapse menu

  const [isMini, setIsMini] = useState(true); // collapse menu
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();

  const isDesktop =
    useMediaQuery(theme.breakpoints.up('lg'), {
      defaultMatches: true,
    }) && user;


    useEffect(() => {
      if(!isDesktop){
          setMobileIsShow(true)
      }


  }, [pathname]);
  useEffect(() => {
    const signOut = () => {
      AuthService.logout();
      navigate('/');
    };
    AuthService.isAuthenticated() && setUser(true);
    if (Object.entries(businessInfo).length > 0 || dataBussinesss || localStorage.getItem('DataFetched') === '0') {
      return;
    }


    if (AuthService.isAuthenticated()) {
      setUser(true);
      (async () => {
        try {
          const result = await getBusinessApi();
          const data = result?.result;
          setDataBussinesss(data);
          setBusinessDispatcher(data);
        } catch (error) {
          if (error?.response?.status === 500) {
            const env = process.env?.REACT_APP_ENVIRONMENT;

            createToast(
              'خطا',
              env ? `کسب وکار شما در محیط ${env} یافت نشد!` : 'کسبوکار شما یافت نشد!',
              'danger',
            );
            signOut();
          }
        }
      })();
    }
  }, [navigate, setBusinessDispatcher, setUser, localStorage.getItem('DataFetched')]);


  useEffect(() => {
    if (!isDesktop) {
      setIsMini(true)
      setMobileIsShow(true)
      setIsShowContent(true)
    }
  }, [])
  const [openSidebar, setOpenSidebar] = useState(true);
  const shouldOpenSidebar = isDesktop ? true : openSidebar;
  const handleSidebarOpen = () => {
    setIsMini(!isMini)
    setMobileIsShow(!mobileIsShow);
    setIsShowContent(!isShowContent)


  };
  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };


  /**
   * لوکال استورج کاملا پاک شود یا لاگ اوت کند ، تمام تب های باز از سامانه را لاگوت میکند
   */
  window.addEventListener("storage", function () {
    if (!localStorage.length && String(this.window.location.pathname).toLowerCase() != '/sign-in') {
      this.window.location.href = '/sign-in'
    }
  }, false);

  // /**
  //  * طبق صحبتی که داشتیم با خانم قلی نیا، این سرویس ها در ابتدای ورود کاربر صدا زده خواهد شد تا اطلاعات اولیه آماده سازی شود- سرویس ها مربوط به حساب ها میباشد
  //  */
  // const defaultCallServices = async () => {
  //   try {
  //     reportAccountNumber()
  //       .then((accounts) => {
  //         const rows = accounts?.result?.rows;
  //         const item = rows.find((a) => a.cols[29] == 'PODLAND_WALLET').cols;
  //         const d = {
  //           filterVOS: [],
  //           parentParams: [],
  //           orderByElementVOS: [],
  //         };
  //         const p = {
  //           page: 0,
  //           size: 10,
  //           accountId: item[0],
  //           startDate: '1401/10/25 00:00:00',
  //           endDate: '1401/11/02 00:00:00',
  //         };
  //         reportTransaction(d, p)
  //           .then((res) => { })
  //           .catch((e) => { });
  //       })
  //       .catch((err) => { });
  //   } catch (error) { }
  // };
  return (
    <>
      {localStorage.getItem('TOKEN') && (
        <div
          className={clsx({
            [classes.root]: true,
            [classes.shiftContent]: isDesktop && !isMini,
            [classes.miniMenuContent]: isMini,
          })}
        >
          <div className={classes.contentPage}>
            {localStorage.getItem('TOKEN') && String(window.location.pathname).toLocaleLowerCase() !== '/sign-in' && <Topbar onSidebarOpen={handleSidebarOpen} />}
            {localStorage.getItem('TOKEN') && String(window.location.pathname).toLocaleLowerCase() !== '/sign-in' && (
              <div className={clsx(classes.sidebarMobile, mobileIsShow ? 'mobileMenu' : 'showmenuMobile')}>
                <SidebarNew setIsShowContent={setIsShowContent} onClose={handleSidebarClose} isClose={isMini} setIsClose={setIsMini} />
              </div>
            )}
            <motion.div
              className={clsx(classes.content, isShowContent ? '' : 'showContent')}
              key={pathname}
              initial="initial"
              animate="in"
              variants={pageVariants}
              transition={pageTransition}
            >
              <div>
                <div className={classes.contentParent}>
                  {children}
                </div>

                {children && (
                  <div className={classes.copyWrite}>
                    <div className={classes.copyWriteText}> کلیه حقوق وب سایت متعلق به <a href='https://bpi.ir'> بانک پاسارگاد</a> می‌باشد.</div>
                    {/* <div className={classes.copyWriteText}>Powered by <a href="https://fanap.ir/">FANAP</a></div> */}
                  </div>
                )}
              </div>
            </motion.div>
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
